<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="520px"
    top="20vh"
    :close-on-click-modal="false"
    class="update-nickname-dialog"
    @closed="handleClosed"
  >
    <div style="text-align: center;" class="dialog-title">修改真实姓名</div>
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-width="68px"
      class="nickname-form"
    >
      <el-form-item label="真实姓名" prop="nickname">
        <el-input
          v-model="form.nickname"
          placeholder="请输入真实姓名"
          clearable
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button :disabled="loading" @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleSubmit"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { updateNickname, userInfo as fetchUserInfo } from "@/api/login";
import { getStore, setStore } from "@/utils/auth";

export default {
  name: "UpdateNicknameDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nickname: {
      type: String,
      default: "",
    },
  },
  data() {
    const validateNickname = (rule, value, callback) => {
      if (!(value || "").trim()) {
        callback(new Error("请输入真实姓名"));
        return;
      }
      callback();
    };

    return {
      loading: false,
      form: {
        nickname: "",
      },
      rules: {
        nickname: [{ validator: validateNickname, trigger: "blur" }],
      },
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(value) {
        if (value) {
          this.syncFormNickname(this.nickname);
        }
      },
    },
    nickname(value) {
      if (this.visible) {
        this.syncFormNickname(value);
      }
    },
  },
  methods: {
    syncFormNickname(value) {
      this.form.nickname = (value || "").trim();
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    handleCancel() {
      if (this.loading) {
        return;
      }
      this.dialogVisible = false;
    },
    handleClosed() {
      this.syncFormNickname(this.nickname);
    },
    async handleSubmit() {
      if (this.loading || !this.$refs.formRef) {
        return;
      }

      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return;
        }

        const nickname = this.form.nickname.trim();
        this.loading = true;
        try {
          await updateNickname({ nickname });
          const latestUserInfo = await this.refreshUserInfo(nickname);
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.$emit("success", latestUserInfo);
        } catch (error) {
          console.error("修改姓名失败:", error);
        } finally {
          this.loading = false;
        }
      });
    },
    async refreshUserInfo(fallbackNickname) {
      try {
        const res = await fetchUserInfo();
        if (res && res.data) {
          setStore("userInfo", res.data);
          this.notifyUserInfoUpdated(res.data);
          return res.data;
        }
      } catch (error) {
        console.error("刷新用户信息失败:", error);
      }

      const nextUserInfo = {
        ...this.getCachedUserInfo(),
        nickname: fallbackNickname,
      };
      setStore("userInfo", nextUserInfo);
      this.notifyUserInfoUpdated(nextUserInfo);
      return nextUserInfo;
    },
    getCachedUserInfo() {
      const cachedUserInfo = getStore("userInfo");
      if (!cachedUserInfo) {
        return {};
      }

      try {
        return JSON.parse(cachedUserInfo);
      } catch (error) {
        return {};
      }
    },
    notifyUserInfoUpdated(userInfo) {
      if (typeof window === "undefined") {
        return;
      }
      window.dispatchEvent(
        new CustomEvent("user-info-updated", {
          detail: userInfo,
        })
      );
    },
  },
};
</script>

<style lang="less" scoped>
.update-nickname-dialog {
  /deep/ .el-dialog {
    border-radius: 12px;
    overflow: hidden;
  }

  /deep/ .el-dialog__header {
    padding: 24px 24px 0;
  }

  /deep/ .el-dialog__body {
    padding: 12px 24px 0;
  }

  /deep/ .el-dialog__footer {
    padding: 24px;
  }
}

.dialog-title {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
}

.dialog-subtitle {
  margin-top: 8px;
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}

.nickname-form {
  margin-top: 24px;
}

.dialog-footer {
  text-align: right;
}
</style>
